let React = require('react');
const FormatMessage = require('react-globalize').FormatMessage;

let SectionSubpoemaLaw_es = React.createClass({

  render : function () {
    return (
      <section id="section4" className="content-section  about-section sectionPage">
        <div className='row'>
          <div className="col-lg-8 col-lg-offset-2 col-sm-10 col-sm-offset-1">
            <div className="title-v1">
              <div className="row">
                  <div className="col-sm-12   col-xs-12">
                      <h1 className="text-center">PROCEDIMIENTOS DE BARRI PARA REQUERIMIENTO DE LAS AUTORIDADES DEL GOBIERNO</h1>
                      <hr className="small"/>
                      <p>LAS AGENCIAS POLICIALES DE LOS ESTADOS UNIDOS QUE ENTREGAN CITACIONES, ÓRDENES JUDICIALES Y ÓRDENES QUE DEBEN SER CONTESTADAS POR BARRI MONEY SERVICES, LLC.</p>
                  </div>
              </div>
              <div className='row'>
                <div className='col-sm-12 col-xs-12 col-md-12 col-lg-12'>
                  <p>El Departamento de Cumplimiento Legal de Barri responderá a las solicitudes de aplicación de la ley, como citaciones, órdenes de allanamiento, órdenes judiciales, solicitudes para testificar u otras formas de solicitudes de cumplimiento de conformidad con la ley aplicable.</p>
                  <p>Para garantizar una respuesta rápida, solicitamos a las fuerzas del orden público que cumplan con los siguientes requisitos al enviar una solicitud:</p>
                </div>
              </div>
              <div className='row'>
                <div className='col-sm-12 col-xs-12 col-md-12 col-lg-12'>
                  <ol>
                    <li>El correo electrónico es la forma preferida de recibir una solicitud: envíenos un correo electrónico a <a href='mailto:subpoenas@barri.com'>subpoenas@barri.com</a></li>
                    <li>También puede enviar su solicitud por correo, nuestra dirección es 10777 Westheimer Road, Suite 1040, Houston,TX 77042, USA.</li>
                    <li>Por favor Incluya una dirección de correo electrónico en todas las solicitudes, ya que la política de Barri es proporcionar registros e información solo a través de correo electrónico cifrado seguro.</li>
                  </ol>
                </div>
              </div>
              <div className='row'>
                <div className='col-sm-12 col-xs-12 col-md-12 col-lg-12'>
                  <p>
                    <b>Tenga en cuenta:</b>  
                  </p>
                </div>
              </div>
              <div className='row'>
                <div className='col-sm-12 col-xs-12 col-md-12 col-lg-12'>
                  <ul>
                    <li>Nuestro aviso de privacidad establece cómo Barri maneja los datos personales y está disponible en  <a href='/bfgPrivacySt' target="_blank">https://www.barri.com/bfgPrivacySt</a></li>
                    <li>La zona horaria predeterminada de los datos de transferencia de dinero transaccional se proporciona en la hora central de EE. UU. (CST).</li>
                    <li>Todas las citaciones deben ir acompañadas del nombre completo, título, dirección postal, dirección de correo electrónico, número de teléfono y número de fax de la persona y/o entidad que emite la citación y el nombre completo, título, dirección postal, dirección de correo electrónico, número de teléfono número y número de fax de la persona a quien se deben enviar los documentos. Sin esta información, Barri no puede procesar las citaciones.</li>
                    <li><b>Barri</b> no mantiene registros de videos de las ubicaciones de sus Agentes en el curso ordinario de los negocios.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }

})

export default SectionSubpoemaLaw_es;


// WEBPACK FOOTER //
// ./js/subpoena/subpoena_es.js